import { io } from "socket.io-client";
import { SOCKET_SERVER_URL } from "./url";

class SocketService {
  constructor() {
    this.socket = null;
    this.currentRoom = null;
    this.listeners = new Set();
  }

  connect() {
    if (this.socket) return;

    console.log("Connecting to WebSocket server:", SOCKET_SERVER_URL);
    this.socket = io(SOCKET_SERVER_URL, {
      transports: ["websocket"], // force Websocket transport as required by server
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: Infinity
    });

    this.socket.on("connect", () => {
      console.log("Connected to WebSocket Server:", this.socket.id);
      // Re-subscribe if we had an active room before disconnection
      if (this.currentRoom) {
        this.socket.emit("join_market", this.currentRoom);
      }
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Disconnected from WebSocket Server:", reason);
    });

    this.socket.on("odds_update", (data) => {
      this.listeners.forEach((callback) => {
        try {
          callback(data);
        } catch (e) {
          console.error("Error in WebSocket odds_update callback:", e);
        }
      });
    });

    this.socket.on("connect_error", (error) => {
      console.error("WebSocket connection error:", error);
    });
  }

  subscribe(marketId, callback) {
    this.connect();

    if (callback) {
      this.listeners.add(callback);
    }

    if (this.currentRoom !== marketId) {
      this.currentRoom = marketId;
      console.log(`Subscribing to market room: ${marketId}`);
      this.socket.emit("join_market", marketId);
    }
  }

  unsubscribe(callback) {
    if (callback) {
      this.listeners.delete(callback);
    }

    if (this.listeners.size === 0 && this.socket) {
      console.log(`No more listeners. Unsubscribing from room: ${this.currentRoom}`);
      this.currentRoom = null;
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

export default new SocketService();
